import { DgtPdProductionOrder } from "../models";
import { useEffect, useState, useMemo } from 'react'
import { getClaimOrders } from '../states/PicklistAction'
import { getISOStartOfDate, getISOEndOfDate } from '../utilities/Format'

export default function useClaimOrder(
  dateFrom: Date | null,
  dateTo: Date | null,
  search: string,
  sort: string
) : [ DgtPdProductionOrder[], (updatedOrders: DgtPdProductionOrder[]) => void]{
  const [orders, setOrders] = useState<DgtPdProductionOrder[]>([]);

  const mutate = (updatedOrders: DgtPdProductionOrder[]) => {
    setOrders(updatedOrders);
  };

  useEffect(() => {
    if (!dateFrom || !dateTo) return

    getClaimOrders(getISOStartOfDate(dateFrom || new Date()), getISOEndOfDate(dateTo || new Date()))
      .then(results => {
      setOrders(results)
    })
    .catch(err => console.error(err))
  }, [ dateFrom, dateTo ]);

  const filteredOrders = useMemo(() => orders.filter(ord => ord.id.includes(search) || ord.materialCode.includes(search)), [ search, orders ])
  // sort by order id
  if (sort === 'unselect') {
    filteredOrders.sort((a, b) => (a.fgInspectionTypes || '').localeCompare(b.fgInspectionTypes || ''))
  } else if (sort === 'order') {
    filteredOrders.sort((a, b) => a.id.localeCompare(b.id))
  } else if (sort === 'material') {
    filteredOrders.sort((a, b) => a.materialCode.localeCompare(b.materialCode))
  } else if (sort === 'brand') {
    filteredOrders.sort((a, b) => (a.materialMrp || '').localeCompare(b.materialMrp || ''))
  }
  return [ filteredOrders, mutate ]
}